import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { changePassword } from '../api';
import Button from './ui/Button';

function ChangePasswordForm({ onDone }) {
  const { t } = useTranslation();

  const [currentPassword, setCurrentPassword] =
    useState('');

  const [newPassword, setNewPassword] = useState('');

  const [confirmPassword, setConfirmPassword] =
    useState('');

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const [error, setError] = useState('');

  function clearError() {
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (newPassword.length < 8) {
      setError(
        t('changePassword.errorLength'),
      );

      return;
    }

    if (newPassword !== confirmPassword) {
      setError(t('changePassword.errorMismatch'));
      return;
    }

    try {
      setIsSubmitting(true);
      setError('');

      await changePassword({
        currentPassword,
        newPassword,
      });

      onDone(t('changePassword.success'));
    } catch (submitError) {
      console.error(
        'Failed to change password:',
        submitError,
      );

      setError(
        submitError.message ||
          t('changePassword.errorGeneric'),
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <form
      className="account-form"
      onSubmit={handleSubmit}
      noValidate
    >
      {error && (
        <div
          className="login-message login-message-error"
          role="alert"
        >
          <i className="fa-solid fa-circle-exclamation" />
          <span>{error}</span>
        </div>
      )}

      <div className="account-field-row">
        <label htmlFor="currentPassword">
          {t('changePassword.currentPasswordLabel')}
        </label>

        <input
          id="currentPassword"
          name="currentPassword"
          type="password"
          autoComplete="current-password"
          value={currentPassword}
          disabled={isSubmitting}
          onChange={(event) => {
            setCurrentPassword(event.target.value);
            clearError();
          }}
        />
      </div>

      <div className="account-field-row">
        <label htmlFor="newPassword">
          {t('changePassword.newPasswordLabel')}
        </label>

        <input
          id="newPassword"
          name="newPassword"
          type="password"
          autoComplete="new-password"
          value={newPassword}
          disabled={isSubmitting}
          onChange={(event) => {
            setNewPassword(event.target.value);
            clearError();
          }}
        />
      </div>

      <div className="account-field-row">
        <label htmlFor="confirmPassword">
          {t('changePassword.confirmPasswordLabel')}
        </label>

        <input
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          disabled={isSubmitting}
          onChange={(event) => {
            setConfirmPassword(event.target.value);
            clearError();
          }}
        />
      </div>

      <div className="account-actions">
        <Button
          variant="secondary"
          disabled={isSubmitting}
          onClick={() => onDone(null)}
        >
          {t('changePassword.cancel')}
        </Button>

        <Button
          variant="primary"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting
            ? t('changePassword.updating')
            : t('changePassword.update')}
        </Button>
      </div>
    </form>
  );
}

export default ChangePasswordForm;
